/*
url-builder.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('urlBuilder',['angular'], function () {

// Module Dependencies
    var dependencies = [];

    // Module Definition
    var mod = angular.module('Services.UrlBuilder', dependencies);

    /**
     * @name urlBuilder
     * @type factory
     *
     * @description
     * A factory that provides methods for building URLs.
     */
    mod.factory('urlBuilder', ['$log', function ($log) {
        /**
         * Public API
         */
        return {
            buildUrl: buildUrl
        };

        /**
         * Builds a URL that includes the specified parameters.
         *
         * @param baseUrl
         *    The base url to attach parameters to.
         *
         * @param params
         *    An object map of parameters that should be added to the base url.
         *
         * @return
         *    A URL with parameters for each property in the provided 'params' object.
         */
        function buildUrl(baseUrl, params) {
            // Validate arguments
            if (angular.isString(baseUrl) === false) {
                var baseUrlErrorMsg = 'Error: urlBuilder: buildUrl: invalid parameter: baseUrl = ' + baseUrl;
                $log.error(baseUrlErrorMsg);
                return baseUrl;
            }
            if (angular.isObject(params) === false) {
                var errorMsg = 'Error: urlBuilder: buildUrl: invalid parameter: params = ' + params;
                $log.error(errorMsg);
                return baseUrl;
            }

            var url = angular.copy(baseUrl),
                paramCount = 0;

            for (var property in params) {
                if (params.hasOwnProperty(property)) {
                    // Add property as a URL parameter
                    url += (paramCount > 0) ? '&' : '?';
                    url += property + '=';

                    // Increment the URL parameter count
                    paramCount++;

                    // Get the property's associated value
                    var value = params[property];

                    // Handle arrays
                    if (angular.isArray(value) && value.length > 0) {
                        url += value[0];
                        for (var i = 1, iEnd = value.length; i < iEnd; i++) {
                            url += ',' + value[i];
                        }
                    }

                    // Handle strings
                    if (angular.isString(value)) {
                        url += value;
                    }
                }
            }

            return url;
        }

    }]);

});

